module.exports = __webpack_public_path__ + "img/galeria-especie-exotica-12.418da520.jpg";